type Props = { className?: string };

export function SignalMesh({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 800 500" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <defs>
        <radialGradient id="meshGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#0A84FF" stopOpacity="0.35" />
          <stop offset="60%" stopColor="#0057FF" stopOpacity="0.08" />
          <stop offset="100%" stopColor="#0057FF" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="meshLine" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#0057FF" stopOpacity="0" />
          <stop offset="50%" stopColor="#0A84FF" stopOpacity="0.7" />
          <stop offset="100%" stopColor="#0057FF" stopOpacity="0" />
        </linearGradient>
      </defs>

      <circle cx="400" cy="250" r="240" fill="url(#meshGlow)" />

      {/* signal waves */}
      {Array.from({ length: 7 }).map((_, i) => (
        <path
          key={i}
          d={`M 0 ${180 + i * 22} Q 200 ${120 + i * 18}, 400 ${180 + i * 22} T 800 ${180 + i * 22}`}
          stroke="url(#meshLine)"
          strokeWidth="1"
          opacity={0.35 + i * 0.05}
          className="pulse-glow"
          style={{ animationDelay: `${i * 0.3}s` }}
        />
      ))}

      {/* network nodes */}
      {[
        [120, 150], [220, 230], [340, 180], [460, 280], [560, 190],
        [660, 260], [400, 340], [300, 360], [520, 360], [180, 320],
      ].map(([x, y], i) => (
        <g key={i}>
          <circle cx={x} cy={y} r="2.5" fill="#0A84FF" />
          <circle cx={x} cy={y} r="8" fill="#0A84FF" opacity="0.18" className="pulse-glow" style={{ animationDelay: `${i * 0.2}s` }} />
        </g>
      ))}
      {/* connecting paths */}
      {[
        ["M120 150 L340 180", 0.4],
        ["M340 180 L460 280", 0.5],
        ["M460 280 L560 190", 0.4],
        ["M220 230 L300 360", 0.3],
        ["M400 340 L520 360", 0.4],
        ["M560 190 L660 260", 0.5],
        ["M180 320 L300 360", 0.3],
      ].map(([d, o], i) => (
        <path key={i} d={d as string} stroke="#0A84FF" strokeWidth="0.8" opacity={o as number} />
      ))}
    </svg>
  );
}

export function GowitekMark({ className = "" }: { className?: string }) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <defs>
          <linearGradient id="gw" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#0057FF" />
            <stop offset="100%" stopColor="#0A84FF" />
          </linearGradient>
        </defs>
        <path d="M12 2 L22 7 V17 L12 22 L2 17 V7 Z" stroke="url(#gw)" strokeWidth="1.6" fill="none" />
        <circle cx="12" cy="12" r="3" fill="url(#gw)" />
      </svg>
      <span className="font-display font-semibold tracking-tight">Gowitek</span>
    </div>
  );
}

export function SignalLogo({ className = "", dark = false }: { className?: string; dark?: boolean }) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <span className="relative inline-flex h-6 w-6 items-center justify-center">
        <span className="absolute inset-0 rounded-full" style={{ background: "var(--gradient-signal)", filter: "blur(8px)", opacity: 0.6 }} />
        <span className="relative h-2.5 w-2.5 rounded-full" style={{ background: "var(--gradient-signal)" }} />
      </span>
      <span className={`font-display font-semibold tracking-tight ${dark ? "text-white" : "text-foreground"}`}>
        Signal <span className="text-gradient">AI</span>
      </span>
    </div>
  );
}
